// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file types/v1/csv.proto (package types.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file types/v1/csv.proto.
 */
export const file_types_v1_csv: GenFile = /*@__PURE__*/
  fileDesc("ChJ0eXBlcy92MS9jc3YucHJvdG8SCHR5cGVzLnYxIi4KC0NTVkZpbGVEYXRhEhEKCWZpbGVfbmFtZRgBIAEoCRIMCgRkYXRhGAIgASgMQp0BCgxjb20udHlwZXMudjFCCENzdlByb3RvUAFaQmdpdGh1Yi5jb20vZW5lY2hhaW4vZXBvc2l0aW9uLWFwcC9iYWNrZW5kL2dlbi9wcm90by90eXBlcy92MTt0eXBlc6ICA1RYWKoCCFR5cGVzLlYxygIIVHlwZXNcVjHiAhRUeXBlc1xWMVxHUEJNZXRhZGF0YeoCCVR5cGVzOjpWMWIGcHJvdG8z");

/**
 * @generated from message types.v1.CSVFileData
 */
export type CSVFileData = Message<"types.v1.CSVFileData"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Describes the message types.v1.CSVFileData.
 * Use `create(CSVFileDataSchema)` to create a new message.
 */
export const CSVFileDataSchema: GenMessage<CSVFileData> = /*@__PURE__*/
  messageDesc(file_types_v1_csv, 0);

